import { apiFetch } from "./client.js";

export interface PendingTransfer {
  rowKey: string;
  fromKidId: string;
  toKidId: string;
  amountCents: number;
  note: string;
  requestedAt: string;
}

export interface KidBundle {
  user: {
    rowKey: string;
    name: string;
    role: "kid";
    color?: string;
    colorSoft?: string;
    avatarShape?: string;
    age?: number;
  };
  account: { balanceCents: number; allowanceCents: number; otherIncomeCents: number };
  goals: Array<{
    rowKey: string;
    title: string;
    targetCents: number;
    savedCents: number;
    icon: string;
    allocType: "$" | "%";
    allocValue: number;
  }>;
  recentTxns: Array<{
    rowKey: string;
    date: string;
    type: string;
    amountCents: number;
    note: string;
  }>;
  pendingTransfers: PendingTransfer[];
  bills: Array<{
    rowKey: string;
    description: string;
    amountCents: number;
    monthsTotal: number;
    monthsRemaining: number;
  }>;
  siblings: Array<{
    rowKey: string;
    name: string;
    color?: string;
    colorSoft?: string;
    avatarShape?: string;
  }>;
  settings: { interestRateAnnualBasisPoints: number };
}

export interface ParentBundle {
  user: { rowKey: string; name: string; role: "parent" };
  family: Array<{
    user: KidBundle["user"];
    account: KidBundle["account"];
    recentTxns: KidBundle["recentTxns"];
  }>;
  settings: KidBundle["settings"];
  pendingTransfers: PendingTransfer[];
}

export async function fetchMe(): Promise<KidBundle | ParentBundle> {
  return apiFetch<KidBundle | ParentBundle>("/api/me");
}
